import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuInputsOption} from '@Components/contextual-menu/components/contextual-menu-inputs-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTabItem} from '@Hooks/poster-editor/useGetKeyFromTabItem';

export function TabsContentOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemText = useGetKeyFromTabItem('text');

  if (!activeItem) {
    throw new Error('Active Item is null');
  }

  if (!activeItem.isTab() || itemText === undefined) {
    throw new Error(`Expected tab item, instead got ${activeItem.gitype}`);
  }

  const onInputChange = (value: string): void => {
    void activeItem.updateFromObject(
      {
        text: value,
      },
      {undoable: false}
    );
  };

  const onInputChangeEnded = (value: string): void => {
    void activeItem.updateFromObject({
      text: value,
      textStyles: activeItem.textStyles.getLanguageScriptAndFontForText(value),
    });
  };

  return (
    <ContextualMenuInputsOption
      id="tabs-content-option"
      isMultiline
      maxNumberOfRows={5}
      value={itemText}
      onInputChange={onInputChange}
      onInputChangeEnded={onInputChangeEnded}
      elementTitle={window.i18next.t('pmwjs_add_your_text')}
    />
  );
}
